/**
 * Set item with an expiry time in localStorage.
 */
export function setWithExpiry(key: string, value: string, ttl: number): void {
  const item = {
    value: value,
    expiry: new Date().getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

/**
 * Get an item that has an expiry time from localStorage.
 * Returns null if the item is expired.
 */
export function getWithExpiry(key: string): string | null {
  const itemString = window.localStorage.getItem(key);

  if (!itemString) {
    return null;
  }

  const item = JSON.parse(itemString);
  const isExpired = new Date().getTime() > item.expiry;

  if (isExpired) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

export const storageTokenKey = '__auth_provider_token__';
export const delayMfaStorageKey = '__delay_mfa__';
